/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ComponentBase from '../ComponentBase';

/** Class used to signify component is child of another component class. */
@cc._decorator.ccclass
export default class ChildComponent<T extends cc.Component> extends ComponentBase
{
    /** Parent component to this component. */
    protected parent: T = null;
    /** Public getter to parent. */
    public get Parent(): T { return this.parent; }
    /** Public setter for parent. */
    public set Parent(value: T) { this.parent = value; }
}
